/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_ViarealityInputs */

const cs_enum_viareality = /** @type {(inputs: Enum_ViarealityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viareality`)
};

const en_enum_viareality = /** @type {(inputs: Enum_ViarealityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viareality`)
};

/**
* | output |
* | --- |
* | "Viareality" |
*
* @param {Enum_ViarealityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_viareality = /** @type {((inputs?: Enum_ViarealityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_ViarealityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_viareality(inputs)
	return cs_enum_viareality(inputs)
});